import { useMemo } from 'react'
import { useGetCargo, useGetSearch, useGetTypeUser } from '../state/filters'
import { useFetchUserAdmin } from '../services/useFetchUserAdmin'
import { useCurrentUser } from '@/features/auth/state/auth'
import { camposFiltrados, CampoServico } from '@/features/products/utils'
import { makeEmpty } from '@/features/permissions/util/utils'

export default function useAllUsers() {
  const { data: users = [], isLoading: loadingUsers, error: userError } = useFetchUserAdmin()
  const user = useCurrentUser()
  const selectedCargo = useGetCargo()
  const selectedTypeUser = useGetTypeUser()
  const searchTerm = useGetSearch()

  const normalizedUsers = useMemo(() => {
    return users.map((u: any) => {
      // 1) parte fixa
      const base = makeEmpty(u.id)

      // 2) parte dinâmica: converte o array de strings em flags boolean
      const fromApi = (u.permissions as string[] | undefined)?.reduce(
        (acc, key) => {
          // só seta se for uma das chaves válidas
          if ((camposFiltrados as string[]).includes(key)) {
            acc[key as CampoServico] = true
          }
          return acc
        },
        {} as Record<CampoServico, boolean>
      )

      return {
        ...u,
        permissions: {
          ...base,
          ...fromApi
        }
      }
    })
  }, [users])

  const filteredUsers = useMemo(() => {
    return normalizedUsers.filter((u: any) => {
      const matchesCategory = selectedCargo === 'Todos' || u.typeCargo === selectedCargo
      const matchesUserType = selectedTypeUser === 'Todos' || u.typeUser === selectedTypeUser
      const matchesSearchTerm =
        u.cpf?.includes(searchTerm) ||
        u.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        u.email?.toLowerCase().includes(searchTerm.toLowerCase())

      // CEO vê tudo
      if (user?.typeCargo === 'CEO') {
        return matchesCategory && matchesUserType && matchesSearchTerm
      }
      // ANALISTA com gestor_product
      if (user?.typeCargo === 'ANALISTA' && user.permissions.permission_product) {
        if (u.id === user.id) return false

        // agora temos flags boolean corretas em u.permissions
        const hasMatchingProductPermission = camposFiltrados.some(
          campo => user.permissions[campo] && u.permissions[campo]
        )

        return hasMatchingProductPermission && matchesCategory && matchesUserType && matchesSearchTerm
      }
    })
  }, [normalizedUsers, selectedCargo, selectedTypeUser, searchTerm, user])

  return { users: normalizedUsers, filteredUsers, loadingUsers, userError }
}
